import { baseModule } from '@/container-modules/base-module';
import { headerServiceModule } from '@/container-modules/header-service-module';
import { agentContainer } from '@/domains/agent';
import { projectContainer } from '@/domains/project';
import { roadmapContainer } from '@/domains/roadmap';
import { sharedContainer } from '@/domains/shared';
import { agenticSearchContainer } from '@/domains/agentic-search';
import { coverageContainer } from '@/domains/coverage';
import { biTrackModule } from '@eureka/domains';
import { saveToProjectModule } from '@eureka/shared/save-to-project/services';
import { authModule } from '@eureka/shared/share-tools/src/domain/auth-module';
import { Container } from '@patsnap/tahiti-core/shared/inversify';

const container = new Container({
    defaultScope: 'Singleton',
    skipBaseClassChecks: true,
});

container.load(
    baseModule,
    headerServiceModule,
    sharedContainer,
    authModule,
    biTrackModule,
    roadmapContainer,
    agentContainer,
    saveToProjectModule,
    projectContainer,
    agenticSearchContainer,
    coverageContainer
);

export {
    container,
};
